import styled from 'styled-components';

import { useI18nValues } from '@/entities/vfo/hooks/useI18nValues';
import { ActivationStatus, UserStatus } from '@/entities/vfo/types';
import { COLORS } from '@/shared/constants/colors';
import { BFC } from '@/shared/types';

import { DotColorByStatus } from './StatusDot';

type StatusCellProps = {
  status: UserStatus;
  activationStatus: ActivationStatus;
  showText?: boolean;
};

export const StatusCell: BFC<StatusCellProps> = ({
  status,
  activationStatus,
  showText = true,
  ...props
}) => {
  const { userStatus } = useI18nValues();
  return (
    <Container {...props}>
      <DotColorByStatus
        status={status}
        isVfoActivated={activationStatus === ActivationStatus.ACTIVE}
      />
      {showText && <span> {userStatus(status, activationStatus)}</span>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${COLORS.systemDark300};
`;
